<template>
  <section class="section section-soft">
    <div class="container advantage-wrap">
      <div class="adv-copy" v-reveal>
        <span class="section-eyebrow">WHY US</span>
        <h2 class="section-title">为什么选择<br /><em>浩连科技</em></h2>
        <p class="adv-desc">
          6 年深耕软件定制开发，我们不仅是代码的执行者，更是您产品落地的合作伙伴。以结果为导向，用专业与责任交付每一个项目。
        </p>

        <ul class="adv-list">
          <li v-for="(a, i) in advantages" :key="a.title" v-reveal="{ delay: i * 100 }">
            <span class="adv-num num">{{ String(i + 1).padStart(2, '0') }}</span>
            <div>
              <h3>{{ a.title }}</h3>
              <p>{{ a.desc }}</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="adv-visual" v-reveal="{ delay: 150 }">
        <img
          :src="imgUrl(
            'modern software development team working together in bright office, code on large screens, collaborative atmosphere, blue tone photography, professional workspace, high quality',
            'portrait_4_3'
          )"
          alt="浩连科技研发团队"
          loading="lazy"
        />
        <div class="exp-badge">
          <b class="num">6+</b>
          <span>年行业深耕</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { imgUrl } from '@/utils/img'

const advantages = [
  { title: '需求前置，杜绝返工', desc: '深入业务场景，输出可执行的原型与方案，开发前即对齐预期。' },
  { title: '全栈团队，一站式交付', desc: '产品、UI、前后端、测试、运维闭环协作，一个团队管到底。' },
  { title: '敏捷迭代，透明可控', desc: '每周进度同步、里程碑节点交付，关键决策全程可见。' },
  { title: '交付即服务，长期陪伴', desc: '上线不是终点，提供质保期内免费维护与持续迭代建议。' }
]
</script>

<style scoped>
.advantage-wrap {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 72px;
  align-items: center;
}

.adv-desc {
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.9;
  color: var(--hl-text-2);
}

.adv-list {
  margin-top: 36px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.adv-list li {
  display: flex;
  gap: 18px;
  padding: 18px 0;
  border-bottom: 1px dashed var(--hl-line);
}

.adv-num {
  font-size: 22px;
  font-weight: 700;
  color: var(--hl-blue);
  opacity: 0.85;
  line-height: 1.4;
  flex-shrink: 0;
}

.adv-list h3 {
  font-size: 17px;
  font-weight: 700;
  color: var(--hl-text);
}

.adv-list p {
  margin-top: 6px;
  font-size: 14px;
  color: var(--hl-text-2);
  line-height: 1.8;
}

/* 视觉区 */
.adv-visual {
  position: relative;
}

.adv-visual img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: 20px;
  box-shadow: var(--shadow-lg);
}

.exp-badge {
  position: absolute;
  right: -18px;
  bottom: 32px;
  padding: 18px 26px;
  border-radius: 16px;
  background: #fff;
  box-shadow: var(--shadow-lg);
  border-left: 4px solid var(--hl-blue);
  display: flex;
  flex-direction: column;
}

.exp-badge b {
  font-size: 32px;
  font-weight: 700;
  color: var(--hl-blue);
}

.exp-badge span {
  font-size: 13px;
  color: var(--hl-text-2);
}

@media (max-width: 992px) {
  .advantage-wrap {
    grid-template-columns: 1fr;
    gap: 48px;
  }
}

@media (max-width: 768px) {
  .exp-badge {
    right: 8px;
    bottom: 16px;
    padding: 14px 20px;
  }
  .exp-badge b {
    font-size: 26px;
  }
}
</style>
